<i18n lang="json">
{
  "en": {
    "FAQ": "Frequently Asked Questions"
  },
  "fr": {
    "FAQ": "Questions fréquemment posées"
  }
}
</i18n>

<template>
  <Container class="mt-8">
    <h2 class="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">{{ t('FAQ') }}</h2>

    <dl
      class="mx-auto mt-8 grid max-w-2xl grid-cols-1 gap-x-8 gap-y-4 text-base leading-7 sm:grid-cols-2 lg:mx-0 lg:max-w-none lg:grid-cols-3"
    >
      <PlaceFaqItem v-for="faq in faqs" :key="faq.id" :faq="faq" />
    </dl>
  </Container>
</template>

<script lang="ts" setup>
import type { PlaceFaq } from '~/types/api'

const props = defineProps<{
  faqs: PlaceFaq[]
}>()

const { t } = useI18n()

useJsonld(() => ({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: props.faqs.map((faq) => ({
    '@type': 'Question',
    name: faq.question!,
    acceptedAnswer: {
      '@type': 'Answer',
      text: faq.answer!
    }
  }))
}))
</script>
